export const Devices = {
  IPHONE_10: "iphone-10",
};

export const BgColors = {
  WHITE: "#ffffff",
  PURPLE: "#5239ae",
  RED: "#9E252A",
  GREEN: "#EBF4DE",
  DARK: "#222222",
  BLUE: "#2E4C89",
  BROWN: "#504B46",
  PINK: "#F4E5E4",
};
